/* milnovecientostres · mejoras 19-oct: rejilla sin colores repetidos, foto puesta al cambiar color, confianza en el carrito */
(function () {
  var el = document.getElementById('mapa-1903');
  var M = {};
  try { M = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { M = {}; }
  var P = M.p || {};

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // 1 · Un solo producto por diseño en cada rejilla (se queda el primero según el orden de la colección)
  function unaPorDiseno() {
    var grids = document.querySelectorAll('ul.grid, ul.product-grid');
    for (var i = 0; i < grids.length; i++) {
      var seen = {};
      var items = grids[i].children;
      for (var j = 0; j < items.length; j++) {
        var li = items[j];
        if (li.tagName !== 'LI') continue;
        var a = li.querySelector('.card-wrapper a[href*="/products/"]');
        if (!a) continue;
        var info = P[li.getAttribute('data-h1903') || (function () { var h = handleOf(a); li.setAttribute('data-h1903', h); return h; })()];
        if (!info || !(info[0] >= 0)) continue;
        var k = 'g' + info[0];
        if (seen[k]) li.classList.add('dd1903'); else { seen[k] = 1; li.classList.remove('dd1903'); }
      }
    }
  }

  // 2 · Al cambiar de color en una tarjeta, la foto del ratón también cambia
  function fotoPuesta(imgs) {
    for (var i = 0; i < imgs.length; i++) if (/\/colchoneros-/.test(imgs[i])) return imgs[i];
    return imgs[2] || imgs[1] || imgs[0];
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.c1903c__dot');
    if (!dot || dot.classList.contains('is-active')) return;
    var card = dot.closest('.card-wrapper'), hv = card && card.querySelector('.hv1903');
    if (!hv) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + dot.getAttribute('data-h') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var u = fotoPuesta(p.images || []);
        if (!u) return;
        u = (u.indexOf('//') === 0 ? 'https:' + u : u);
        hv.removeAttribute('srcset');
        hv.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720';
      }).catch(function () {});
  });

  // 3 · Confianza y métodos de pago bajo el botón de pagar (carrito lateral y página del carrito)
  function confianza() {
    var tpl = document.getElementById('tr1903-tpl');
    if (!tpl) return;
    var ctas = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      var after = c.nextElementSibling && c.nextElementSibling.classList.contains('cart__dynamic-checkout-buttons') ? c.nextElementSibling : c;
      if (after.nextElementSibling && after.nextElementSibling.classList.contains('tr1903')) continue;
      after.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    }
  }

  function run() { unaPorDiseno(); confianza(); }
  function init() {
    run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Etiquetas (Más vendido / Nuevo) encima del nombre, no sobre la foto */
(function () {
  function etiquetas() {
    var ts = document.querySelectorAll('.card-wrapper .e1903--tarjeta:not([data-mv])');
    for (var i = 0; i < ts.length; i++) {
      var t = ts[i];
      t.setAttribute('data-mv', '1');
      var c = t.closest('.card-wrapper');
      var hs = c.querySelectorAll('.card__heading');
      var h = hs[hs.length - 1];
      if (!h || c.querySelector('.tg1903')) continue;
      var w = document.createElement('div');
      w.className = 'tg1903';
      [].forEach.call(t.querySelectorAll('.e1903__tag'), function (s) {
        var e = document.createElement('span');
        e.className = 'tg1903__t' + (s.classList.contains('e1903__tag--nuevo') ? ' is-new' : '');
        e.textContent = s.textContent;
        w.appendChild(e);
      });
      h.parentNode.insertBefore(w, h);
    }
  }
  function init() {
    etiquetas();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(etiquetas, 200); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* 1903 · "También te gustará": sin el diseño que estás viendo, sin repetidos y máximo 4 */
(function () {
  var el = document.getElementById('mapa-1903'), P = {};
  try { P = (JSON.parse(el ? el.textContent : '{}') || {}).p || {}; } catch (e) {}
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  var cur = m ? decodeURIComponent(m[1]) : null;
  var curG = cur && P[cur] && P[cur][0] >= 0 ? P[cur][0] : null;
  function hOf(a) { var x = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return x ? decodeURIComponent(x[1]) : null; }
  function fix() {
    var rs = document.querySelectorAll('product-recommendations.related-products ul');
    for (var i = 0; i < rs.length; i++) {
      var seen = {}, shown = 0, lis = rs[i].children;
      for (var j = 0; j < lis.length; j++) {
        var li = lis[j], a = li.querySelector('a[href*="/products/"]');
        if (!a) continue;
        var h = hOf(a), info = P[h], g = info && info[0] >= 0 ? 'g' + info[0] : 'h' + h;
        var hide = h === cur || (curG !== null && info && info[0] === curG) || seen[g] || shown >= 4;
        seen[g] = 1;
        li.style.display = hide ? 'none' : '';
        if (!hide) shown++;
      }
    }
  }
  function init() {
    fix();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 120); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
